module.exports = __webpack_public_path__ + "img/sol_cap5.baef228e.png";